module.exports = "<div class=\"product-markers\">\n    <div ng-repeat=\"marker in markers\">\n        <div ng-if=\"marker.type == 0\" class=\"marker-basic marker-size-{{size}}\">\n            <span ng-style=\"{'background-color': marker.background_color, 'color': marker.color}\">{{marker.text}}</span>\n        </div>\n        <div ng-if=\"marker.type == 1 && marker.img_url\" class=\"marker-image marker-size-{{size}}\">\n            <img ng-src=\"{{marker.img_url}}\">\n        </div>\n        \n    </div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./scripts/apps/shop/directives/views/product-markers.html
// module id = 374
// module chunks = 0